import { render, staticRenderFns } from "./upload-file.vue?vue&type=template&id=a86c0af4&scoped=true&"
import script from "./upload-file.vue?vue&type=script&lang=js&"
export * from "./upload-file.vue?vue&type=script&lang=js&"
import style0 from "./upload-file.vue?vue&type=style&index=0&id=a86c0af4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a86c0af4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\公司文件\\web\\uni-platform\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a86c0af4')) {
      api.createRecord('a86c0af4', component.options)
    } else {
      api.reload('a86c0af4', component.options)
    }
    module.hot.accept("./upload-file.vue?vue&type=template&id=a86c0af4&scoped=true&", function () {
      api.rerender('a86c0af4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/modal/upload-file.vue"
export default component.exports